import React from 'react';
import { reduxForm, Field } from 'redux-form';
import Form from 'components/Form';
import InputField from 'components/InputField';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';

class ActivationForm extends React.Component {
  state = {
    isOpenModal: false,
  };

  openModal = () => {
    this.setState({ isOpenModal: true });
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  render() {
    const { isOpenModal } = this.state;
    const {
      saveStatus,
      activationResponse: activation,
      isAdmin,
      isAgent,
      isManager,
      remoteSubmit,
    } = this.props;
    if (saveStatus === 'SUCCEEDED') {
      return (
        <div>
          <p>Success: {String(activation.success)}</p>
          <p>PIN: {activation.pin}</p>
          <p>Details:</p>
          <pre>{JSON.stringify(activation.details, null, 2)}</pre>
        </div>
      );
    }

    return (
      <React.Fragment>
        <h1>Account Activation</h1>
        <Form {...this.props} noSubmitBtn>
          <Field component={InputField} name="pin" />
          {(isAdmin || isAgent || isManager) && (
            <React.Fragment>
              <Field component={InputField} name="mdn" />
            </React.Fragment>
          )}
          <button
            type="button"
            className="btn btn-default"
            disabled={saveStatus === 'PENDING'}
            onClick={this.openModal}
          >
            Activate Subscription
          </button>
        </Form>
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm Activation"
          description={`Are you sure you would like to activate this subscription?`}
          onClose={this.closeModal}
          onConfirm={remoteSubmit}
        />
      </React.Fragment>
    );
  }
}

export default reduxForm({
  form: 'activateAttSub',
})(ActivationForm);
